//@flow

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { Node } from 'react'

import Modal from '../../../Modal'
import ModalBody from '../../../Modal/ModalBody'
import ModalRow from '../../../Modal/ModalRow'
import ModalLabel from '../../../Modal/ModalLabel'
import ModalCloseButton from '../../../Modal/ModalCloseButton'
import ModalButtons from '../../../Modal/ModalButtons'
import ModalHead from '../../../Modal/ModalHead'
import { useOverflow } from '../../../../hooks/useOverflow'
import NewSelectSimple from '../../../NewSelectSimple'
import Button from '../../../Button'

import styles from '../FilterModal/FilterModal.module.scss'

function RelatedFilterModal(props): Node {
  const { isOpen, filters } = props

  const { t } = useTranslation('Request')

  const recipientTypeOptions = [
    { value: 'request_owner', label: t('RequestOwner') },
    { value: 'request_contractor', label: t('RequestContractor') },
  ]

  const excludeArchivedOptions = [
    { value: false, label: t('IncludeArchived') },
    { value: true, label: t('NotIncludeArchived') },
  ]

  const [recipientTypeOption, setRecipientTypeOption] = useState(
    recipientTypeOptions.find(o => filters.recipient_type === o.value)
  )
  const [excludeArchivedOption, setExcludeArchivedOption] = useState(
    excludeArchivedOptions.find(
      o => filters.exclude_archived_requests === o.value
    )
  )

  useOverflow()

  const handleApply = () => {
    props.setRelatedFilters({
      recipient_type: recipientTypeOption.value,
      exclude_archived_requests: excludeArchivedOption.value,
    })

    props.onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      className={styles.modal}
      onRequestClose={props.onClose}
    >
      <ModalHead title={t('Mail:FilterTitle')} />
      <ModalCloseButton onClose={props.onClose} />
      <ModalBody>
        <ModalRow>
          <ModalLabel>{t('RecipientTypeLabel')}</ModalLabel>
        </ModalRow>
        <ModalRow>
          <NewSelectSimple
            className={styles.select}
            options={recipientTypeOptions}
            value={recipientTypeOption}
            onChange={setRecipientTypeOption}
          />
        </ModalRow>
        <ModalRow>
          <ModalLabel>{t('ExcludeArchivedLabel')}</ModalLabel>
        </ModalRow>
        <ModalRow>
          <NewSelectSimple
            className={styles.select}
            options={excludeArchivedOptions}
            value={excludeArchivedOption}
            onChange={setExcludeArchivedOption}
          />
        </ModalRow>
      </ModalBody>
      <ModalButtons className={styles.buttons}>
        <Button.Save onClick={handleApply}>{t('Mail:ApplyFilter')}</Button.Save>
        <Button.Cancel onClick={props.onClose}>
          {t('Common:Cancel')}
        </Button.Cancel>
      </ModalButtons>
    </Modal>
  )
}

export default RelatedFilterModal
